import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowTableData } from './table-enums.js';

const positionalUncertaintyMap = new Map();

positionalUncertaintyMap.set(KnowTableData.DepthMD, {
  key: KnowTableData.DepthMD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth MD',
});

positionalUncertaintyMap.set(KnowTableData.Inclination, {
  key: KnowTableData.Inclination,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'Inclination',
});

positionalUncertaintyMap.set(KnowTableData.Azimuth, {
  key: KnowTableData.Azimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'Azimuth',
});

positionalUncertaintyMap.set(KnowTableData.DepthTVD, {
  key: KnowTableData.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth TVD',
});

positionalUncertaintyMap.set(KnowTableData.HighSideError, {
  key: KnowTableData.HighSideError,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'High Side Error',
});

positionalUncertaintyMap.set(KnowTableData.LateralError, {
  key: KnowTableData.LateralError,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'Lateral Error',
});

positionalUncertaintyMap.set(KnowTableData.AlongHoleError, {
  key: KnowTableData.AlongHoleError,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'Along Hole Error',
});

positionalUncertaintyMap.set(KnowTableData.VerticalError, {
  key: KnowTableData.VerticalError,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'Vertical Error',
});

positionalUncertaintyMap.set(KnowTableData.SemiMajorError, {
  key: KnowTableData.SemiMajorError,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'Semi Major Error',
});

positionalUncertaintyMap.set(KnowTableData.SemiMinorError, {
  key: KnowTableData.SemiMinorError,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'Semi Minor Error',
});

positionalUncertaintyMap.set(KnowTableData.SemiMinorAzimuth, {
  key: KnowTableData.SemiMinorAzimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'Semi Minor Azimuth',
});

positionalUncertaintyMap.set(KnowTableData.ToolIPMFileName, {
  key: KnowTableData.ToolIPMFileName,
  unit: '',
  label: 'Tool (IPM File Name)',
});

export {
  positionalUncertaintyMap,
};
